module.exports = {"posts":[],"projects":[{"id":"asteroids","title":"Asteroids","description":"Fun game that runs in the browser","url":"https://asteroid-canvas.mcdrmtt.co/"},{"id":"render-3d-canvas","title":"3D renderer in JS","description":"Creating a simple 3D renderer in JS","url":"https://render-3d-canvas.mcdrmtt.co/"},{"id":"memory","title":"Memory","description":"Find pairs","url":"https://memory-preact-unsplash.glitch.me/"}]}


//////////////////
// WEBPACK FOOTER
// ./src/content.json
// module id = 370
// module chunks = 35783957827783